import React from 'react';

import { UseMyMoneyContainer } from '@/modules/UseMyMoney';

const UseMyMoneyPage = () => {
  return <UseMyMoneyContainer />;
};

export default UseMyMoneyPage;
